import * as SystemActions from './../../system/actions/system.actions';
import { IRegistrantsState, registrantAdapter } from './../../state/registrants.state';

import * as registrationActions from '../actions/registration.actions';
import { initialRegistrantsState } from '../../state/registrants.state';

export function RegistrantReducer(state = initialRegistrantsState, action: registrationActions.RegistrationActions | SystemActions.SystemActions): IRegistrantsState {
    switch (action.type) {
        case registrationActions.REGISTER_LOAD_STEPS_SUCCESS: {
            return registrantAdapter.addMany(action.payload.registration.registrants, state);
        }

        case registrationActions.REGISTER_SAVE_SUCCESS:
        case registrationActions.REGISTER_FINAL_SAVE_SUCCESS: {
            return registrantAdapter.setAll(action.payload.registration.registrants, state);
        }

        case registrationActions.REGISTER_FAIL:
            return {
                ...state,
                entities: {},
                failText: action.payload.failtext
            };

        case registrationActions.REGISTER_UPDATE_PERSONAL_DETAILS:
        case registrationActions.REGISTER_UPDATE_TAX_DETAILS:
        case registrationActions.REGISTER_UPDATE_SOURCE_WEALTH:
        case registrationActions.REGISTER_UPDATE_VERIFICATION_DETAILS:
            return registrantAdapter.updateOne(action.payload, state);

        case registrationActions.REGISTER_ADD_REGISTRANT:
            return registrantAdapter.addOne(action.payload.registrant, state);
        case SystemActions.CLEAR_SYSTEM:
            return initialRegistrantsState;
        default:
            return state;
    }
}
